import script from "./GameCommand.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameCommand.vue?vue&type=script&setup=true&lang=ts"

import "./GameCommand.vue?vue&type=style&index=0&id=6a1c6dd3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a1c6dd3"]])

export default __exports__